import { AccordionItem } from "@szhsin/react-accordion";
import { DownArrowIcon } from "assets/icons";
import { useTranslation } from "react-i18next";
import { Icon } from "ui";

import { NavAccordionProps } from "./NavAccordion.types";

import styles from "./NavAccordion.module.scss";

const NavAccordion = ({ route, ...rest }: NavAccordionProps) => {
  const { t } = useTranslation();

  return (
    <AccordionItem
      {...rest}
      header={
        <div className={styles.header}>
          <div className={styles.header_icon}>{route.icon}</div>
          {t(route.label)}

          <Icon
            as={DownArrowIcon}
            boxSize={24}
            color="#7E7E8B"
            className={styles.accordion_chevron}
          />
        </div>
      }
      className={styles.accordion}
      buttonProps={{
        className: ({ isEnter }) =>
          `${styles.accordion_accordionBtn} ${
            isEnter && styles.accordion_accordionBtnExpanded
          }`
      }}
      contentProps={{ className: styles.accordion_accordionContent }}
      panelProps={{ className: styles.accordion_accordionPanel }}
    />
  );
};

export default NavAccordion;
